import { ScanLine, ShoppingBasket, CreditCard, ShoppingBag } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import { useContent } from "../lib/content";

const STEPS = [
    {
        icon: ScanLine,
        title: "Você acessa",
        text: "Abra a porta pelo app, QR Code ou cartão do condomínio. Simples assim.",
        tid: "step-1-access",
    },
    {
        icon: ShoppingBasket,
        title: "Escolhe os produtos",
        text: "Gôndonas e geladeiras abastecidas: do lanche rápido ao jantar de hoje.",
        tid: "step-2-choose",
    },
    {
        icon: CreditCard,
        title: "Paga como preferir",
        text: "No totem de autoatendimento: Pix, cartão ou aproximação.",
        tid: "step-3-pay",
    },
    {
        icon: ShoppingBag,
        title: "É só levar!",
        text: "Sem fila e sem espera. Simples, rápido e seguro.",
        tid: "step-4-enjoy",
    },
];

export default function ComoFunciona() {
    const t = useContent().passos;
    return (
        <section
            id="como-funciona"
            className="scroll-mt-24 relative bg-gradient-to-b from-[#073A22] to-[#0E6B3F] text-[#F7F4EC] py-20 sm:py-28 overflow-hidden"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6 relative">
                <Reveal className="text-center max-w-2xl mx-auto">
                    <SectionTag tone="yellow">Do apartamento à geladeira</SectionTag>
                    <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
                        {t.title}
                    </h2>
                    <p className="font-caveat text-3xl sm:text-4xl text-[#F1C75B] mt-3 -rotate-1">
                        {t.subtitle}
                    </p>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.tid} delay={i * 0.1}>
                            <div
                                data-testid={s.tid}
                                className="group relative h-full rounded-[1.75rem] border-2 border-[#F7F4EC]/20 bg-[#F7F4EC]/5 backdrop-blur-sm p-7 hover:bg-[#F7F4EC]/10 hover:-translate-y-1.5 transition-all duration-300"
                            >
                                <span className="absolute -top-5 -left-3 w-14 h-14 rounded-2xl bg-[#F57A3A] text-[#F7F4EC] text-2xl font-black grid place-items-center sticker rotate-[-6deg] group-hover:rotate-6 transition-transform duration-300">
                                    {i + 1}
                                </span>
                                <s.icon className="w-9 h-9 text-[#F1C75B] mt-6" strokeWidth={2} />
                                <h3 className="mt-4 text-xl font-extrabold">{t.steps[i]?.t || s.title}</h3>
                                <p className="mt-2.5 text-sm sm:text-base text-[#F7F4EC]/80 leading-relaxed">
                                    {t.steps[i]?.d || s.text}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
